// The document toolbar's Finalize button: when it's blocked and what it says.
// Pure, so the rules are unit-tested.

export interface FinalizeInput {
  isContainer: boolean;
  isEmailWithChildren: boolean;
  allChildrenCompleted: boolean;
  approvedCount: number;
  pendingCount: number;
}

/**
 * Why Finalize can't run right now, or null. Nothing approved does NOT block it
 * (FR-02): the document then finalizes with no redactions.
 */
export function finalizeBlockedReason(f: FinalizeInput): string | null {
  if (f.isContainer) return f.allChildrenCompleted ? null : 'Complete all child documents before finalizing';
  if (f.isEmailWithChildren && !f.allChildrenCompleted) return 'Complete all child attachments before finalizing';
  return null;
}

/** The button's tooltip: the blocker, or what clicking it will do. */
export function finalizeTitle(f: FinalizeInput): string {
  const blocked = finalizeBlockedReason(f);
  if (blocked) return blocked;
  if (f.isContainer) return 'Finalize and download redacted archive';
  if (f.approvedCount > 0) return 'Apply redactions and finalize';
  return f.pendingCount > 0
    ? 'Nothing approved: reject the pending suggestions and finalize with no redactions'
    : 'Nothing approved: finalize with no redactions';
}
